var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDraft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#draft_svg__clip0_202_12151)",
    stroke: "#000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 17.5h-1.25a.625.625 0 01-.625-.625v-2.5M9.375 2.5h2.5l4.375 4.375v3.75M3.75 5V3.125a.625.625 0 01.625-.625H6.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 2.5v4.375h4.375M16.25 13.75v3.125a.624.624 0 01-.625.625H15M3.75 8.125v3.125M8.75 17.5h3.125"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "draft_svg__clip0_202_12151"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgDraft;